'use client';

import { signInAction } from '@/app/actions';
import { FormMessage, type Message } from '@/components/form-message';
import { Login3 } from '@/components/login3';
import { Button } from '@/components/ui/button';
import { createClient } from '@/utils/supabase/client';
import { redirect, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

const defaultLogo = {
  url: 'https://www.shadcnblocks.com',
  src: 'https://shadcnblocks.com/images/block/logos/shadcnblockscom-icon.svg',
  alt: 'Shadcnblocks',
};

export default function Login(props: { searchParams: Promise<Message> }) {
  const [message, setMessage] = useState<Message | null>(null);
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const supabase = createClient();

  useEffect(() => {
    props.searchParams.then((msg) => {
      if (msg) setMessage(msg);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleSubmit(formData: FormData) {
    setLoading(true);
    const result = await signInAction(formData);
    // signInAction may redirect, but if it returns an error/message, show it
    if (
      result &&
      typeof result === 'object' &&
      ('success' in result || 'error' in result || 'message' in result)
    ) {
      redirect('/dashboard');
    }
    setLoading(false);
  }

  // todo
  // https://console.cloud.google.com/apis/credentials?pli=1&inv=1&invt=AbwmSw&project=favoritewalks
  // https://supabase.com/docs/guides/auth/social-login/auth-google
  const handleGoogleSignIn = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
      },
    });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full">
      <div className="flex flex-col items-center w-full">
        <Button variant="ghost" className="mb-6" type="button" onClick={() => router.back()}>
          ← Back
        </Button>
        <form className="w-full max-w-md" action={handleSubmit}>
          <Login3
            heading="Sign in"
            subheading="Welcome back!"
            loginText={loading ? 'Signing in...' : 'Sign in'}
            signupText="Don't have an account?"
            signupUrl="/sign-up"
            googleText="Sign in with Google"
            logo={defaultLogo}
            emailName="email"
            passwordName="password"
            onGoogleSignIn={handleGoogleSignIn}
          />
        </form>
        {message && <FormMessage message={message} />}
      </div>
    </div>
  );
}
